import { useRef, useState } from 'react';
import { Popper, Card, CardContent, Typography, Box } from '@mui/material';
import { ASTooltip } from '../../../shared/as-tooltip/as-tooltip';

export function UserInfoTooltip({ userInfo, className = null }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [isHovering, setIsHovering] = useState(false);
    const iconRef = useRef(null);
    const hoverTimeout = useRef(null);

    const handleMouseEnter = (event) => {
        if (event) event.stopPropagation();
        if (hoverTimeout.current) clearTimeout(hoverTimeout.current); // Cancel close
        setAnchorEl(iconRef.current);
        setIsHovering(true);
    };

    const handleMouseLeave = () => {
        hoverTimeout.current = setTimeout(() => {
            setIsHovering(false);
            setAnchorEl(null);
        }, 100);
    };

    const handlePopoverEnter = () => {
        if (hoverTimeout.current) clearTimeout(hoverTimeout.current);
        setAnchorEl(iconRef.current);
        setIsHovering(true);
    };

    const handlePopoverLeave = () => {
        hoverTimeout.current = setTimeout(() => {
            setAnchorEl(null);
            setIsHovering(false);
        }, 100);
    };

    const open = Boolean(anchorEl) && isHovering;

    return (
        <>
            <ASTooltip onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                ref={iconRef}
                className={className || "i-icon"} />

            <Popper open={open} anchorEl={anchorEl}  disableRestoreFocus
                onMouseEnter={handlePopoverEnter} onMouseLeave={handlePopoverLeave}
                sx={{ zIndex: 1500 }}>
                <Card sx={{ minWidth: 200, borderRadius: 3, boxShadow: 3, backgroundColor: 'white' }} onMouseLeave={handleMouseLeave}>
                    <CardContent >
                        {userInfo &&
                            <Box sx={{
                                display: 'grid',
                                alignItems: 'center',
                                gap: .2,
                            }}
                            >
                                <Typography sx={{ color: 'text.secondary', fontSize: 10, fontWeight: 'bold', minWidth: '100px' }}>
                                    User Details
                                </Typography>
                                <Box>
                                    {Object.entries(userInfo || {}).map(([key, value]) => (
                                        <Typography key={key} sx={{ color: 'text.secondary', fontSize: 10 }}>
                                            {`${key} - ${value}`}
                                        </Typography>
                                    ))}
                                </Box>
                            </Box>}
                    </CardContent>
                </Card>
            </Popper>
        </>
    );
}
